import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import {Checkbox as Check, AngleDown} from "../assets/svg";
import {Button} from "../ui/button";
import { ChevronDown } from "lucide-react";
import { cn } from "../lib/utils";

export const sortByTimeFrame = [
  { text: "Past 1 month", value: "month" },
  { text: "Past 1 year", value: "year" },
  { text: "Past 1 week", value: "week" },
  { text: "Past 24 hours", value: "day" },
];

const FilterDropDown = ({
  allTime,
  mainTitle,
  label,
  dropDownList = sortByTimeFrame,
  onSelect,
  selected,
}: {allTime: boolean, mainTitle: string, label: string, onSelect: (value: string) => void, selected: string, dropDownList: {text: string, value: string}[]}) => {
    const currentItem = dropDownList?.find((item) => item.value === selected);
    return (
    <DropdownMenu>
      <DropdownMenuTrigger className="outline-none focus-within:outline-0">
        {allTime ? (
          <p className="flex items-center gap-2 text-base font-normal text-gray-10">
            {selected ? dropDownList?.find((item) => item.value === selected)?.text : "All time"}
              <AngleDown />
          </p>
        ) : (
          <>
            {mainTitle ? (
              <Button
                variant="ghost"
                    className="flex items-center bg-primary-70 rounded-[10px] justify-center gap-1 px-3 py-1 text-sm"
              >
                    <span className="font-[350] text-gray-10">{mainTitle}:</span>
                {label && (
                      <span className="flex items-center font-[450] text-gray-10">
                    {currentItem?.text || label} <ChevronDown size={18} />
                  </span>
                )}
              </Button>
            ) : null}
          </>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-white border-0 shadow-md rounded-[8px] gap-1 flex flex-col outline-0 focus-within:outline-0 focus-visible:outline-none focus-visible:outline-0">
        {dropDownList?.map(({ text, value }, index) => {
          const isSelected = selected === value;
          return (
            <DropdownMenuItem
              key={index}
              className={cn(
                "flex justify-between hover:bg-primary-50 cursor-pointer !rounded-[8px]",
                isSelected ? "bg-primary-50" : ""
              )}
              onClick={() => onSelect?.(value)}
            >
              <span>{text}</span> {isSelected && <Check />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default FilterDropDown;
